/**
 * Selector to get permissions from splash data
 * @param {Object} state - Redux state
 * @returns {Array} Array of permission strings
 */
export const selectPermissions = (state) => {
    return state.splash?.data?.permissions || [];
};

